import { render, staticRenderFns } from "./RegisterShop.vue?vue&type=template&id=2695bb6c&scoped=true&"
import script from "./RegisterShop.vue?vue&type=script&lang=js&"
export * from "./RegisterShop.vue?vue&type=script&lang=js&"
import style0 from "./RegisterShop.vue?vue&type=style&index=0&id=2695bb6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2695bb6c",
  null
  
)

export default component.exports